import BaseApi from '@/_types/api/base.api.class';
import { AxiosRequestConfig, CancelToken } from 'axios';
import NotificationsHelper from '@/_helpers/notifications.helper';

export type TGetUnreadCountParams = {
  eventId: number;
}

export type TGetUnreadCountResponse = {
  messages_count?: number;
  meeting_count?: number;
  // upcoming_meeting: ?
}

export class NotificationsApi extends BaseApi {

  public async getUnreadCount(eventId: number, cancelToken?: CancelToken): Promise<any> {
    const config: AxiosRequestConfig = {
      url: `/event/${eventId}/notification`,
      method: 'GET',
      cancelToken,
    };

    let response;

    try {
      response = await this.axios.request<TGetUnreadCountResponse>(config);
    } catch (error) {
      throw this.responseError(error);
    }
    return NotificationsHelper.responseToNotificationCountConverter(response.data);
  }

}

const notificationsApi = new NotificationsApi();
export default notificationsApi;
